<template>
    <div class="section-box">
        <el-tabs v-model="disposeType" type="card" @tab-click="handleClick">
            <el-tab-pane label="标准工单" name="1"></el-tab-pane>
            <el-tab-pane label="项目工单" name="2"></el-tab-pane>
        </el-tabs>
        <el-form ref="form" :model="settingModal" label-width="145px">
            <div v-loading="loading">
                <div class="fd_title">服务信息</div>
                <div class="fd_content">
                    <el-row>
                        <el-col :span="12">
                            <label class="our_wdith">领域：</label>
                            <el-radio v-model="settingModal.isDomainRequired" :label="true">必填</el-radio>
                        </el-col>
                        <el-col :span="12">
                            <label class="our_wdith">一级产品：</label>
                            <el-radio v-model="settingModal.isFirstProductRequired" :label="true">必填</el-radio>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <label class="our_wdith">二级产品：</label>
                            <el-radio v-model="settingModal.isSecondProductRequired" :label="true">必填</el-radio>
                        </el-col>
                        <el-col :span="12">
                            <label class="our_wdith">三级产品：</label>
                            <el-radio-group v-model="settingModal.isThirdProductRequired">
                                <el-radio :label="true">必填</el-radio>
                                <el-radio :label="false">选填</el-radio>
                            </el-radio-group>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <label class="our_wdith">服务类型：</label>
                            <el-radio v-model="settingModal.isServiceStageRequired" :label="true">必填</el-radio>
                        </el-col>
                        <el-col :span="12">
                            <label class="our_wdith">产品数量：</label>
                            <el-radio v-model="settingModal.isProductQuantityRequired" :label="true">必填</el-radio>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <label class="our_wdith">产品品牌：</label>
                            <el-radio-group v-model="settingModal.isProductBrandRequired">
                                <el-radio :label="true">必填</el-radio>
                                <el-radio :label="false">选填</el-radio>
                            </el-radio-group>
                        </el-col>
                        <el-col :span="12">
                            <label class="our_wdith">产品系列：</label>
                            <el-radio v-model="settingModal.isProductSerialRequired" :label="true">必填</el-radio>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <label class="our_wdith">所属行业：</label>
                            <el-radio-group v-model="settingModal.isIndustryRequired">
                                <el-radio :label="true">必填</el-radio>
                                <el-radio :label="false">选填</el-radio>
                            </el-radio-group>
                        </el-col>
                        <el-col :span="12">
                            <label class="our_wdith">所需工程师数量：</label>
                            <el-radio v-model="settingModal.isEngineerQuantityRequired" :label="true">必填</el-radio>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <label class="our_wdith">服务需求描述：</label>
                            <el-radio-group v-model="settingModal.isServiceDescribeRequired">
                                <el-radio :label="true">必填</el-radio>
                                <el-radio :label="false">选填</el-radio>
                            </el-radio-group>
                        </el-col>
                        <el-col :span="12">
                            <label class="our_wdith">现场资料上传：</label>
                            <el-radio-group v-model="settingModal.isSiteDataUploadRequired">
                                <el-radio :label="true">必填</el-radio>
                                <el-radio :label="false">选填</el-radio>
                            </el-radio-group>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <label class="our_wdith">{{disposeType==1?'服务编号':'Offer编号'}}：</label>
                            <el-radio v-model="settingModal.isOfferIdRequired" :label="true">必填</el-radio>
                        </el-col>
                    </el-row>
                </div>
                <div class="fd_title">基本信息</div>
                <div class="fd_content">
                    <el-row>
                        <el-col :span="12">
                            <label class="our_wdith">工单名称：</label>
                            <el-radio v-model="settingModal.isDisposeNameRequired" :label="true">必填</el-radio>
                        </el-col>
                        <el-col :span="12">
                            <label class="our_wdith">工单地址：</label>
                            <el-radio v-model="settingModal.isDisposeAddressRequired" :label="true">必填</el-radio>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <label class="our_wdith">现场联系人：</label>
                            <el-radio v-model="settingModal.isSiteContactsRequired" :label="true">必填</el-radio>
                        </el-col>
                        <el-col :span="12">
                            <label class="our_wdith">现场联系电话：</label>
                            <el-radio v-model="settingModal.isSiteContactPhoneRequired" :label="true">必填</el-radio>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <label class="our_wdith">备用联系人：</label>
                            <el-radio-group v-model="settingModal.isSpareContactsRequired">
                                <el-radio :label="true">必填</el-radio>
                                <el-radio :label="false">选填</el-radio>
                            </el-radio-group>
                        </el-col>
                        <el-col :span="12">
                            <label class="our_wdith">备用联系方式：</label>
                            <el-radio-group v-model="settingModal.isSpareContactPhoneRequired">
                                <el-radio :label="true">必填</el-radio>
                                <el-radio :label="false">选填</el-radio>
                            </el-radio-group>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <label class="our_wdith">最早上门时间：</label>
                            <el-radio v-model="settingModal.isEarliestDoorTimeRequired" :label="true">必填</el-radio>
                        </el-col>
                        <el-col :span="12">
                            <label class="our_wdith">最晚上门时间：</label>
                            <el-radio v-model="settingModal.isLatestDoorTimeRequired" :label="true">必填</el-radio>
                        </el-col>
                    </el-row>
                    <div v-if="disposeType==1">
                        <el-row>
                            <el-col :span="12" v-if="disposeType==1">
                                <label class="our_wdith">预计服务天数：</label>
                                <el-radio v-model="settingModal.isPreServiceDaysRequired" :label="true">必填</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <label class="our_wdith">上门名义：</label>
                                <el-radio-group v-model="settingModal.isDoorNameRequired">
                                    <el-radio :label="true">必填</el-radio>
                                    <el-radio :label="false">选填</el-radio>
                                </el-radio-group>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <label class="our_wdith">内部工单号：</label>
                                <el-radio-group v-model="settingModal.isInnerDisposeCodeRequired">
                                    <el-radio :label="true">必填</el-radio>
                                    <el-radio :label="false">选填</el-radio>
                                </el-radio-group>
                            </el-col>
                            <el-col :span="12">
                                <label class="our_wdith">所属企业：</label>
                                <el-radio-group v-model="settingModal.isEnterpriseRequired">
                                    <el-radio :label="true">必填</el-radio>
                                    <el-radio :label="false">选填</el-radio>
                                </el-radio-group>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-input v-model="option1.fieldName" class="width_100" maxlength="100" placeholder="预留新选项1"></el-input>
                                <el-radio-group v-model="option1.requiredType">
                                    <el-radio :label="1">必填</el-radio>
                                    <el-radio :label="0">选填</el-radio>
                                    <el-radio :label="-1">不填</el-radio>
                                </el-radio-group>
                            </el-col>
                            <el-col :span="12">
                                <el-input v-model="option2.fieldName" class="width_100" maxlength="100" placeholder="预留新选项2"></el-input>
                                <el-radio-group v-model="option2.requiredType">
                                    <el-radio :label="1">必填</el-radio>
                                    <el-radio :label="0">选填</el-radio>
                                    <el-radio :label="-1">不填</el-radio>
                                </el-radio-group>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-input v-model="option3.fieldName" class="width_100" maxlength="100" placeholder="预留新选项3"></el-input>
                                <el-radio-group v-model="option3.requiredType">
                                    <el-radio :label="1">必填</el-radio>
                                    <el-radio :label="0">选填</el-radio>
                                    <el-radio :label="-1">不填</el-radio>
                                </el-radio-group>
                            </el-col>
                            <el-col :span="12">
                                <el-input v-model="option4.fieldName" class="width_100" maxlength="100" placeholder="预留新选项4"></el-input>
                                <el-radio-group v-model="option4.requiredType">
                                    <el-radio :label="1">必填</el-radio>
                                    <el-radio :label="0">选填</el-radio>
                                    <el-radio :label="-1">不填</el-radio>
                                </el-radio-group>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-input v-model="option5.fieldName" class="width_100" maxlength="100" placeholder="预留新选项5"></el-input>
                                <el-radio-group v-model="option5.requiredType">
                                    <el-radio :label="1">必填</el-radio>
                                    <el-radio :label="0">选填</el-radio>
                                    <el-radio :label="-1">不填</el-radio>
                                </el-radio-group>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="disposeType==2">
                        <el-row>
                            <el-col :span="12">
                                <label class="our_wdith">最低预算总价：</label>
                                <el-radio v-model="settingModal.isLowestBudgetRequired" :label="true">必填</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <label class="our_wdith">最高预算总价：</label>
                                <el-radio v-model="settingModal.isMaximumBudgetRequired" :label="true">必填</el-radio>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <label class="our_wdith">上门名义：</label>
                                <el-radio-group v-model="settingModal.isDoorNameRequired">
                                    <el-radio :label="true">必填</el-radio>
                                    <el-radio :label="false">选填</el-radio>
                                </el-radio-group>
                            </el-col>
                            <el-col :span="12">
                                <label class="our_wdith">内部工单号：</label>
                                <el-radio-group v-model="settingModal.isInnerDisposeCodeRequired">
                                    <el-radio :label="true">必填</el-radio>
                                    <el-radio :label="false">选填</el-radio>
                                </el-radio-group>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <label class="our_wdith">所属企业：</label>
                                <el-radio-group v-model="settingModal.isEnterpriseRequired">
                                    <el-radio :label="true">必填</el-radio>
                                    <el-radio :label="false">选填</el-radio>
                                </el-radio-group>
                            </el-col>
                            <el-col :span="12">
                                <el-input v-model="option1.fieldName" class="width_100" maxlength="100" placeholder="预留新选项1"></el-input>
                                <el-radio-group v-model="option1.requiredType">
                                    <el-radio :label="1">必填</el-radio>
                                    <el-radio :label="0">选填</el-radio>
                                    <el-radio :label="-1">不填</el-radio>
                                </el-radio-group>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-input v-model="option2.fieldName" class="width_100" maxlength="100" placeholder="预留新选项2"></el-input>
                                <el-radio-group v-model="option2.requiredType">
                                    <el-radio :label="1">必填</el-radio>
                                    <el-radio :label="0">选填</el-radio>
                                    <el-radio :label="-1">不填</el-radio>
                                </el-radio-group>
                            </el-col>
                            <el-col :span="12">
                                <el-input v-model="option3.fieldName" class="width_100" maxlength="100" placeholder="预留新选项3"></el-input>
                                <el-radio-group v-model="option3.requiredType">
                                    <el-radio :label="1">必填</el-radio>
                                    <el-radio :label="0">选填</el-radio>
                                    <el-radio :label="-1">不填</el-radio>
                                </el-radio-group>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-input v-model="option4.fieldName" class="width_100" maxlength="100" placeholder="预留新选项4"></el-input>
                                <el-radio-group v-model="option4.requiredType">
                                    <el-radio :label="1">必填</el-radio>
                                    <el-radio :label="0">选填</el-radio>
                                    <el-radio :label="-1">不填</el-radio>
                                </el-radio-group>
                            </el-col>
                            <el-col :span="12">
                                <el-input v-model="option5.fieldName" class="width_100" maxlength="100" placeholder="预留新选项5"></el-input>
                                <el-radio-group v-model="option5.requiredType">
                                    <el-radio :label="1">必填</el-radio>
                                    <el-radio :label="0">选填</el-radio>
                                    <el-radio :label="-1">不填</el-radio>
                                </el-radio-group>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <div class="dialog-footer" style="text-align: center;margin-top: 50px;">
                    <el-button type="primary" class="our-button mar-l-43" @click="confirminvoice()">保存</el-button>
                </div>
            </div>

        </el-form>
    </div>
</template>

<script>
    import { getinvoice,saveinvoice} from "@/service/dataFrame";
    import { getStorageUserRoleId } from '@/utils/store'
    export default {
        name: "billingInformation",
        data() {
            return {
                loading:false,
                disposeType: '1',
                settingModal: {
                    isDomainRequired:true,//领域是否必填
                    isFirstProductRequired: true,//一级产品是否必填
                    isSecondProductRequired:true,//二级产品是否必填
                    isThirdProductRequired:false,//三级产品是否必填
                    isServiceStageRequired:true,//服务类型必填
                    isProductQuantityRequired:true,//产品数量是否必填
                    isProductBrandRequired:false,//产品品牌是否必填
                    isProductSerialRequired:false,//产品系列是否必填
                    isIndustryRequired:false,//所属行业是否必填
                    isEngineerQuantityRequired:true,//所需工程师数量是否必填
                    isServiceDescribeRequired:true,//服务需求描述是否必填
                    isSiteDataUploadRequired:true,//现场资料上传是否必填
                    isOfferIdRequired:true,//Offer编号是否必填，
                    isDisposeNameRequired:true,//工单名称是否必填
                    isDisposeAddressRequired:true,//工单地址是否必填
                    isSiteContactsRequired:true,//现场联系人是否必填
                    isSiteContactPhoneRequired:true,//现场联系电话是否必填
                    isSpareContactsRequired:false,//备用联系人是否必填
                    isSpareContactPhoneRequired:false,//备用联系方式是否必填
                    isEarliestDoorTimeRequired:true,//最早上门时间是否必填
                    isLatestDoorTimeRequired:true,//最晚上门时间是否必填
                    isPreServiceDaysRequired:true,//预计服务天数是否必填，标准工单类型才有此属性
                    isLowestBudgetRequired:true,//最低服务预算是否必填，项目工单类型才有此属性
                    isMaximumBudgetRequired:true,//最高服务预算是否必填，项目工单类型才有此属性
                    isDoorNameRequired:false,//上门名义是否必填
                    isInnerDisposeCodeRequired:false,//内部工单编号是否必填
                    isEnterpriseRequired:true,//所属企业是否必填
                },
                option1:{
                    fieldIndex: 1,
                    fieldName: '',
                    requiredType: '-1'
                },
                option2:{
                    fieldIndex: 2,
                    fieldName: '',
                    requiredType: '-1'
                },
                option3:{
                    fieldIndex: 3,
                    fieldName: '',
                    requiredType: '-1'
                },
                option4:{
                    fieldIndex: 4,
                    fieldName: '',
                    requiredType: '-1'
                },
                option5:{
                    fieldIndex: 5,
                    fieldName: '',
                    requiredType: '-1'
                }
            }
        },
        methods: {
            clearinfo(){
                this.option1={
                    fieldIndex: 1,
                    fieldName: '',
                    requiredType: '-1'
                };
                this.option2={
                    fieldIndex: 2,
                    fieldName: '',
                    requiredType: '-1'
                };
                this.option3={
                    fieldIndex: 3,
                    fieldName: '',
                    requiredType: '-1'
                };
                this.option4={
                    fieldIndex: 4,
                    fieldName: '',
                    requiredType: '-1'
                };
                this.option5={
                    fieldIndex: 5,
                    fieldName: '',
                    requiredType: '-1'
                };
            },
            async confirminvoice(){
                let param ={
                    id:this.settingModal.id,
                    disposeType:this.disposeType,
                    userId:getStorageUserRoleId(),
                    isProductBrandRequired:this.settingModal.isProductBrandRequired,
                    isIndustryRequired:this.settingModal.isIndustryRequired,
                    isProductSerialRequired:this.settingModal.isProductSerialRequired,
                    isThirdProductRequired:this.settingModal.isThirdProductRequired,
                    isServiceDescribeRequired:this.settingModal.isServiceDescribeRequired,
                    isSiteDataUploadRequired:this.settingModal.isSiteDataUploadRequired,
                    isSpareContactsRequired:this.settingModal.isSpareContactsRequired,
                    isSpareContactPhoneRequired:this.settingModal.isSpareContactPhoneRequired,
                    isDoorNameRequired:this.settingModal.isDoorNameRequired,
                    isInnerDisposeCodeRequired:this.settingModal.isInnerDisposeCodeRequired,
                    isEnterpriseRequired:this.settingModal.isEnterpriseRequired
                }
                const extendFields=[];
                if(this.option1.fieldName){
                    extendFields.push(this.option1)
                }
                if(this.option2.fieldName){
                    extendFields.push(this.option2)
                }
                if(this.option3.fieldName){
                    extendFields.push(this.option3)
                }
                if(this.option4.fieldName){
                    extendFields.push(this.option4)
                }
                if(this.option5.fieldName){
                    extendFields.push(this.option5)
                }
                param.extendFields=extendFields;
                let res = await saveinvoice(param)
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                console.log("param",param)
                this.$message.success("保存成功")
                this.getinvoiceData();

            },
            handleClick() {
                this.getinvoiceData();
            },
            async getinvoiceData(){
                this.clearinfo();
                this.loading=true;
                let param ={
                    disposeType:this.disposeType,
                    userId:getStorageUserRoleId()
                }
                let res = await getinvoice(param)
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.settingModal=res.Data;
                const arr =res.Data.extendFields;
                for(let i=0;i<arr.length;i++){
                    if(!arr[i].fieldName){
                        arr[i].fieldName='';
                    }
                   this["option"+(arr[i].fieldIndex)] =arr[i]; 
                }
                setTimeout(()=>{
                    this.loading=false;
                },500)
            }
        },
        created() {
            this.getinvoiceData();
        },
        watch: {
            disposeType() {
                this.getinvoiceData();
            },
        }
    }
</script>

<style lang="scss">
    .fd_title {
        height: 50px;
        background: #F2F2F2;
        font-size: 24px;
        line-height: 50px;
        font-weight: 600;
        padding-left: 30px;
        margin-bottom: 20px;
    }

    .fd_content {
        padding-left: 30px;
        .our_wdith{
            width: 300px;
            display: inline-block;
        }
        .el-row{
            padding-bottom: 10px;
            padding-top: 10px;
            display: flex;
            align-items:center;
        }
        .width_100{
            width: 150px;
            margin-right: 150px
        }
    }
</style>
